<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div
        class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded"
      >
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20"
        >
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{
          message.header
        }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button
            :label="message.rejectLabel"
            outlined
            @click="rejectCallback"
            class="w-32"
          ></Button>
          <Button
            :label="message.acceptLabel"
            @click="acceptCallback"
            class="w-32"
          ></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <ModalItem
    v-if="modalShowItem"
    @closeModal="closeModal"
    :item="selectedItem"
  />
  <ModalConfirmStatus
    v-if="showStatusModal"
    @closeModal="closeStatusModal"
    @statusUpdated="fetchItems"
    :item="selectedItem"
  />
  <IndexView />
  <div
    id="overlay"
    class="fixed inset-0 bg-black bg-opacity-30 z-30"
    :class="{ hidden: !isBlur }"
  ></div>
  <ViewContainer>
    <section class="p-6">
      <PageTitle title="Item" />
      <div
        class="border-t-2 border-primary bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg shadow-light-100 dark:shadow-dark-500"
      >
        <div id="table-header" class="mb-5 flex justify-between">
          <AddButton
            to_url="#"
            button_text="+ Tambah Item"
            button_class="text-base py-2 font-medium"
            @click="showModal"
          />
          <InputSelect
            v-if="allowedRoles.includes(role_id)"
            v-model="selectedOutletId"
            id="outlet-select"
            :options="allOutlets"
            placeholder="Pilih outlet"
            optionLabel="name"
            optionValue="id"
          />
        </div>
        <div class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>No</TableHeadCell>
                    <TableHeadCell v-if="allowedRoles.includes(role_id)"
                      >Outlet</TableHeadCell
                    >
                    <TableHeadCell>Code</TableHeadCell>
                    <TableHeadCell>Kategori</TableHeadCell>
                    <TableHeadCell>Nama Item</TableHeadCell>
                    <!-- <TableHeadCell>Menu Type</TableHeadCell> -->
                    <!-- <TableHeadCell>Unit</TableHeadCell> -->
                    <!-- <TableHeadCell>Barcode</TableHeadCell> -->
                    <TableHeadCell numeric>Sale Price</TableHeadCell>
                    <TableHeadCell>Service Charge</TableHeadCell>
                    <TableHeadCell>Tax</TableHeadCell>
                    <TableHeadCell>Discount</TableHeadCell>
                    <TableHeadCell>Status</TableHeadCell>
                    <TableHeadCell>Action</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="allItems.length == 0">
                    <TableCell
                      colspan="12"
                      customClass="text-center italic text-gray-400 dark:text-gray-500"
                      noTextColor
                    >
                      Belum ada data
                    </TableCell>
                  </TableRow>
                  <TableRow
                    v-else
                    v-for="(item, index) in allItems"
                    :key="item.id"
                    :index="index"
                    isBody
                  >
                    <TableCell>{{ index + 1 }}</TableCell>
                    <TableCell v-if="allowedRoles.includes(role_id)">{{
                      getOutletName(item.outlet_id)
                    }}</TableCell>
                    <TableCell>{{ item.code }}</TableCell>
                    <TableCell>{{
                      getCategoryName(item.item_category_id)
                    }}</TableCell>
                    <TableCell>{{ item.name }}</TableCell>
                    <!-- <TableCell>{{ item.menu_type }}</TableCell> -->
                    <!-- <TableCell>{{ item.unit }}</TableCell> -->
                    <!-- <TableCell>
                      <img :src="item.barcode || defaultBarcodeImage" :alt="item.barcode || 'Default Barcode'"
                        class="h-8" @error="$event.target.src = defaultBarcodeImage" />
                    </TableCell> -->
                    <TableCell :rupiah="item.sale_price" />
                    <TableCell>
                      <span
                        :class="{
                          'bg-success dark:bg-success text-light-50 dark:text-white':
                            item.service_charge_applied,
                          'bg-danger dark:bg-danger text-light-50 dark:text-white':
                            !item.service_charge_applied,
                        }"
                        class="px-2 py-1 rounded-full text-xs font-medium"
                      >
                        {{ item.service_charge_applied ? "Ya" : "Tidak" }}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span
                        :class="{
                          'bg-success dark:bg-success text-light-50 dark:text-white':
                            item.tax_applied,
                          'bg-danger dark:bg-danger text-light-50 dark:text-white':
                            !item.tax_applied,
                        }"
                        class="px-2 py-1 rounded-full text-xs font-medium"
                      >
                        {{ item.tax_applied ? "Ya" : "Tidak" }}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span
                        :class="{
                          'bg-success dark:bg-success text-light-50 dark:text-white':
                            item.discount_applied,
                          'bg-danger dark:bg-danger text-light-50 dark:text-white':
                            !item.discount_applied,
                        }"
                        class="px-2 py-1 rounded-full text-xs font-medium"
                      >
                        {{ item.discount_applied ? "Ya" : "Tidak" }}
                      </span>
                    </TableCell>
                    <!-- <TableCell>{{ formatRupiah(item.purchase_price) }}</TableCell> -->
                    <!-- <TableCell>{{ formatRupiah(item.discount_price) }}</TableCell> -->
                    <TableCell>
                      <span
                        :class="{
                          'bg-success dark:bg-success text-light-50 dark:text-white':
                            item.is_active,
                          'bg-danger dark:bg-danger text-light-50 dark:text-white':
                            !item.is_active,
                        }"
                        class="px-2 py-1 rounded-full text-xs font-medium"
                      >
                        {{ item.is_active ? "Aktif" : "Tidak Aktif" }}
                      </span>
                    </TableCell>
                    <TableCell
                      noTextColor
                      customClass="text-gray-500 dark:text-gray-400 flex"
                    >
                      <button
                        :id="'view-data-' + item.id"
                        @click="openStatusModal(item)"
                        class="border border-primary dark:border-blue-300 hover:border-white hover:bg-primary text-primary dark:text-blue-100 hover:text-white flex justify-center items-center mx-1 p-2 rounded-md group"
                      >
                        Ubah Status
                      </button>
                      <button
                        :id="'view-data-' + item.id"
                        @click="goToStockMovement(item)"
                        class="border border-primary dark:border-blue-300 hover:border-white hover:bg-primary text-primary dark:text-blue-100 hover:text-white flex justify-center items-center mx-1 p-2 rounded-md group"
                      >
                        Kartu Stok
                      </button>
                      <!-- <button :id="'view-data-' + item.id" @click="goToBillOfMaterialDetail(item)"
                        class="border border-primary dark:border-dark-50 hover:border-white hover:bg-primary text-primary dark:text-dark-50 hover:text-white flex justify-center items-center mx-1 p-2 rounded-md group">
                        BOM
                      </button> -->
                      <button
                        :id="'edit-data-' + item.id"
                        @click="editItem(item)"
                        class="bg-warning hover:bg-hover-warning flex justify-center items-center mx-1 p-2 rounded-md group"
                      >
                        <PencilSquareIcon
                          class="h-4 w-4 text-light-900 group-hover:text-primary"
                        />
                      </button>
                      <button
                        :id="'delete-data-' + item.id"
                        @click="deleteItem(item)"
                        class="bg-danger hover:bg-hover-danger flex justify-center items-center mx-1 p-2 rounded-md group"
                      >
                        <TrashIcon
                          class="h-4 w-4 text-white group-hover:text-light-50"
                        />
                      </button>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </TableComponent>
              <PaginationButtons
                v-model="currentPage"
                :totalPages="totalPages"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from "@/views/IndexView.vue";
import PageTitle from "@/components/PageTitle.vue";
import AddButton from "@/components/buttons/AddButton.vue";
import ModalItem from "@/components/modals/ModalItem.vue";
import ModalConfirmStatus from "@/components/modals/ModalConfirmStatus.vue";
import ViewContainer from "@/components/ViewContainer.vue";
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";
import { PencilSquareIcon, TrashIcon } from "@heroicons/vue/24/solid";
import { mapGetters, mapActions } from "vuex";
import { formatRupiah } from "@/helpers/formatRupiah";
import defaultBarcode from "@/assets/images/default-image.webp";
import PaginationButtons from "@/components/PaginationButtons.vue";
import { Button, ConfirmDialog, Toast } from "primevue";
import InputSelect from "@/components/form/InputSelect.vue";

export default {
  name: "ItemView",
  components: {
    IndexView,
    PageTitle,
    AddButton,
    ModalItem,
    ViewContainer,
    TableComponent,
    TableHead,
    TableRow,
    TableHeadCell,
    TableBody,
    TableCell,
    PencilSquareIcon,
    TrashIcon,
    PaginationButtons,
    ModalConfirmStatus,
    ConfirmDialog,
    Button,
    Toast,
    InputSelect,
  },
  data() {
    return {
      allowedRoles: ["null", "4"],
      role_id: localStorage.getItem("role_id"),
      modalShowItem: false,
      showStatusModal: false,
      selectedItem: null,
      isBlur: false,
      defaultBarcodeImage: defaultBarcode,
      currentPage: 1,
      totalPages: 1,
      selectedOutletId: null,
      fetchItemsTimeout: null,
    };
  },
  computed: {
    ...mapGetters("items", ["allItems"]),
    ...mapGetters("item_categories", ["allItemCategories"]),
    ...mapGetters("outlets", ["allOutlets"]),
    optionOutlets() {
      return this.allOutlets.map((outlet) => ({
        label: outlet.name,
        value: outlet.id,
      }));
    },
  },
  async created() {
    await this.$store.dispatch("items/fetchItems", { limit: 50 });
    await this.$store.dispatch("item_categories/fetchItemCategories", {
      limit: 1000,
    });
    await this.$store.dispatch("outlets/fetchOutlets", { limit: 1000 });
    this.selectedOutletId = this.allOutlets ? this.allOutlets[0].id : null;
  },
  watch: {
    currentPage: {
      immediate: true,
      handler(newVal) {
        this.fetchItems({ page: newVal });
      },
    },
    selectedOutletId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          // Clear any existing timeout to prevent multiple rapid calls
          if (this.fetchItemsTimeout) {
            clearTimeout(this.fetchItemsTimeout);
          }
          // Set a new timeout
          this.fetchItemsTimeout = setTimeout(() => {
            this.fetchItems({ page: 1 });
          }, 1000);
        }
      },
    },
  },
  methods: {
    ...mapActions("items", ["deleteItemById", "updateItemStatus"]),
    ...mapActions("item_categories", ["fetchItemCategories"]),
    async fetchItems(params = { page: 1, limit: 50 }) {
      if (!params.page) params.page = this.currentPage;
      if (!params.limit) params.limit = 50;

      if (this.allowedRoles.includes(this.role_id) && this.selectedOutletId)
        params.outlet_id = this.selectedOutletId;

      try {
        const { pagination } = await this.$store.dispatch(
          "items/fetchItems",
          params
        );
        if (pagination) {
          this.totalPages = pagination.totalPages;
        }
      } catch (error) {
        console.log(error);
      }
    },
    getOutletName(outletId) {
      const outlet = this.allOutlets.find((outlet) => outlet.id === outletId);
      return outlet && outletId ? outlet.name : "-";
    },
    formatRupiah,
    showModal() {
      this.modalShowItem = true;
      this.isBlur = true;
      this.selectedItem = null;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowItem = false;
        this.isBlur = false;
        this.fetchItems();
      }, 200);
    },
    editItem(item) {
      this.selectedItem = item;
      this.modalShowItem = true;
      this.isBlur = true;
    },
    openStatusModal(item) {
      this.selectedItem = item;
      this.showStatusModal = true;
      this.isBlur = true;
    },
    closeStatusModal() {
      this.showStatusModal = false;
      this.isBlur = false;
      this.selectedItem = null;
    },
    async deleteItem(item) {
      this.$confirm.require({
        group: "headless",
        header: "Apakah anda yakin ingin menghapus item?",
        message: "Silahkan konfirmasi sebelum diproses.",
        acceptLabel: "Ya",
        rejectLabel: "Tidak",
        accept: async () => {
          try {
            await this.deleteItemById(item.id);
            this.fetchItems();
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: "Berhasil menghapus item",
              life: 3000,
            });
          } catch (error) {
            console.error("Gagal menghapus item", error);
            this.$toast.add({
              severity: "error",
              summary: "Failed",
              detail: "Gagal menghapus item",
              life: 3000,
            });
          }
        },
        reject: () => {
          this.$toast.add({
            severity: "error",
            summary: "Rejected",
            detail: "Batal menghapus item",
            life: 3000,
          });
        },
      });
    },
    getCategoryName(categoryId) {
      const category = this.allItemCategories.find(
        (cat) => cat.id === categoryId
      );
      return category ? category.name : "Tidak ada kategori";
    },
    goToBillOfMaterialDetail(item) {
      this.$router.push({
        name: "BillOfMaterialSetup",
        params: { id: item.id },
      });
    },
    goToStockMovement(item) {
      this.$router.push({ name: "StockMovement", params: { id: item.id } });
    },
  },
};
</script>
